import Net from '../../util/net';

type TCommonConfig<T> = {
  data: T;
  ret: number;
  msg: string;
};

export default {
  getCommonConfig<T>(): Promise<TCommonConfig<T>> {
    return Net.request({
      method: 'GET',
      path: 'devtools-api/common-config',
      data: {
        category: 'app-flutter',
      },
    });
  },
};
